import React, { useState, useEffect } from "react";
import AddNewCategory from "./AddCategory";
import { getLabTestCategories,getLabTestCategoryById } from "../../apis/LabOrder";
import { Pagination, PaginationProps } from "antd";
import CommonPagination from "../../components/CommanPagination";

const Categories: React.FC = () => {
  const [categories, setCategories] = useState<any[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editableId, setEditableId] = useState<number | null>(null);
  const [editableCategory, setEditableCategory] = useState<any>(null);
  const [meta, setMeta] = useState<any>();

const fetchCategories = (params: any = { page: 1, per_page: 10 }) => {
    getLabTestCategories(params)
      .then((res: any) => {
        const dataArray = Array.isArray(res.data.data) ? res.data.data : res.data;
        setCategories(dataArray);
        setMeta(res.data.meta || { total: dataArray.length });
      })
      .catch((err) => console.error("Failed to fetch categories:", err));
  };

  useEffect(() => {
    fetchCategories({ page: 1, per_page: 10 });
  }, []);

  const handleEdit = (id: number) => {
    getLabTestCategoryById(id)
      .then((res) => {
        setEditableCategory(res.data.data || res.data);
        setEditableId(id);
        setIsModalOpen(true);
      })
      .catch((err) => console.error("Failed to fetch category:", err));
  };

  const handleModalClose = () => {
    setEditableId(null);
    setEditableCategory(null);
    setIsModalOpen(false);
  };
  
  const handleSuccess = (category: any) => {
    const updatedCategories = categories.map((c) =>
      c.id === category.id ? category : c
    );
    if (!categories.some((c) => c.id === category.id)) {
    updatedCategories.unshift(category);
    }
    setCategories(updatedCategories);
    fetchCategories({ page: 1, per_page: 10 });
    handleModalClose();
  };

  //  const onPaginationChange: PaginationProps["onChange"] = (page, pageSize) => {
  //   fetchCategories({ page, per_page: pageSize || 10 });
  // };
  const onPaginationChange = (page: number, pageSize?: number) => {
  fetchCategories({ page, per_page: pageSize || 10 }); 
};

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4">
        <h1 className="text-base font-semibold leading-6 text-gray-900">
            Lab Test Categories
          </h1>
        <button
          onClick={() => setIsModalOpen(true)}
          className="mt-3 sm:mt-0 px-4 py-2 text-sm font-semibold text-white bg-primary rounded-md hover:bg-hover"
        >
          Add New Category
        </button>
      </div>

      <div className="overflow-x-auto">
        <div className="inline-block min-w-full align-middle">
          <div className="overflow-hidden border border-gray-200 rounded-lg shadow-sm">
            <table className="min-w-full divide-y divide-gray-300">
              <thead className="bg-gray-50">
                <tr>
                  {/* <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">
                    ID
                  </th> */}
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">
                    Name
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {categories.length > 0 ? (
                  categories.map((cat) => (
                    <tr key={cat.id} className="hover:bg-gray-50">
                      {/* <td className="px-4 py-4 text-sm font-medium text-gray-900">
                        {cat.id}
                      </td> */}
                      <td className="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                        {cat.name}
                      </td>
                      <td className="px-2 py-2 text-sm text-gray-900">
                          <button 
                          onClick={() => handleEdit(cat.id)}
                          className="px-3 py-2 text-sm text-white bg-primary rounded hover:bg-hover">
                            Edit
                          </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3} className="px-4 py-4 text-center text-sm text-gray-500">
                      No categories found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {/* <div className="flex justify-end pt-5">
                          <Pagination
                            defaultCurrent={1}
                            defaultPageSize={10}
                            total={meta?.total}
                            onChange={onPaginationChange}
                          />
                        </div> */}
              <CommonPagination meta={meta} onChange={onPaginationChange} />
          </div>
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <AddNewCategory
          isOpen={isModalOpen}
          onClose={handleModalClose}
          editableId={editableId || undefined}
          editableCategory={editableCategory || undefined}
          onSuccess={handleSuccess}
        />
      )}
    </div>
  );
};

export default Categories;
